export var AssetLevel = /*#__PURE__*/function (AssetLevel) {
  // Environment dependent libraries such as react, react-dom
  AssetLevel[AssetLevel["Environment"] = 1] = "Environment";
  // Basic class libraries, such as lodash deep fusion antd
  AssetLevel[AssetLevel["Library"] = 2] = "Library";
  // theme
  AssetLevel[AssetLevel["Theme"] = 3] = "Theme";
  // runtime
  AssetLevel[AssetLevel["Runtime"] = 4] = "Runtime";
  // business components
  AssetLevel[AssetLevel["Components"] = 5] = "Components";
  // Apps & Pages
  AssetLevel[AssetLevel["App"] = 6] = "App";
  return AssetLevel;
}({});
export var AssetLevels = [AssetLevel.Environment, AssetLevel.Library, AssetLevel.Theme, AssetLevel.Runtime, AssetLevel.Components, AssetLevel.App];
export var AssetType = /*#__PURE__*/function (AssetType) {
  AssetType["JSUrl"] = "jsUrl";
  AssetType["CSSUrl"] = "cssUrl";
  AssetType["CSSText"] = "cssText";
  AssetType["JSText"] = "jsText";
  AssetType["Bundle"] = "bundle";
  return AssetType;
}({});